export interface ContactUsModel{
    name: string;
    email: string;
    message: string;
}

export function ContactUsDefaultValues():ContactUsModel
{
    return {name:'',email:'',message:''}
}